var map = {
	".": 18305,
	"./": 18305,
	"./Animations": 61549,
	"./Animations.js": 61549,
	"./Animations/GrowingCircle": 15377,
	"./Animations/GrowingCircle.js": 15377,
	"./Animations/IntroSlide": 97643,
	"./Animations/IntroSlide.js": 97643,
	"./Animations/IntroSlideItem": 89790,
	"./Animations/IntroSlideItem.js": 89790,
	"./Animations/Slide": 25878,
	"./Animations/Slide.js": 25878,
	"./Animations/SlideShow": 27709,
	"./Animations/SlideShow.js": 27709,
	"./Animations/StickyText": 94399,
	"./Animations/StickyText.js": 94399,
	"./Animations/StickyTextMoving": 19252,
	"./Animations/StickyTextMoving.js": 19252,
	"./Animations/stars.jpg": 29839,
	"./App": 48162,
	"./App.js": 48162,
	"./App.test": 60754,
	"./App.test.js": 60754,
	"./Credits": 60160,
	"./Credits.js": 60160,
	"./Graph": 62642,
	"./Graph.js": 62642,
	"./Introduction": 65886,
	"./Introduction.js": 65886,
	"./Main": 9063,
	"./Main.js": 9063,
	"./MarketDeepDives": 53218,
	"./MarketDeepDives.js": 53218,
	"./Navbar": 273,
	"./Navbar.js": 273,
	"./NoLogin": 33122,
	"./NoLogin.js": 33122,
	"./Nothing": 50983,
	"./Nothing.js": 50983,
	"./NotionMedia": 72394,
	"./NotionMedia.js": 72394,
	"./NotionParagraph": 97501,
	"./NotionParagraph.js": 97501,
	"./ProductOpportunities": 75405,
	"./ProductOpportunities.js": 75405,
	"./SidebarLeft": 3869,
	"./SidebarLeft.js": 3869,
	"./SidebarRight": 95769,
	"./SidebarRight.js": 95769,
	"./SlideShowVideos": 89065,
	"./SlideShowVideos.js": 89065,
	"./StitchedText": 71172,
	"./StitchedText.js": 71172,
	"./VideoReels": 76832,
	"./VideoReels.js": 76832,
	"./authContext": 35270,
	"./authContext.js": 35270,
	"./data/networkEdges": 28085,
	"./data/networkEdges.js": 28085,
	"./fonts/Inconsolata.ttf": 78693,
	"./fonts/Inter.ttf": 17864,
	"./fonts/Inter100.ttf": 94040,
	"./fonts/Inter200.ttf": 94469,
	"./fonts/Inter300.ttf": 98518,
	"./fonts/Inter400.ttf": 28283,
	"./fonts/Inter500.ttf": 4430,
	"./fonts/Inter600.ttf": 99505,
	"./fonts/Inter700.ttf": 57943,
	"./fonts/Inter800.ttf": 43900,
	"./fonts/Inter900.ttf": 19728,
	"./gemiclogo_white.png": 93293,
	"./index": 18305,
	"./index.css": 51174,
	"./index.js": 18305,
	"./logo.svg": 31100,
	"./media/arrowCursor.svg": 61540,
	"./media/arrowDiamond.svg": 38182,
	"./media/bbq.png": 68722,
	"./media/bigNode.png": 38807,
	"./media/burger.png": 49673,
	"./media/burger.svg": 15763,
	"./media/burger_white.png": 78175,
	"./media/close.svg": 22161,
	"./media/drag.png": 97206,
	"./media/drip.png": 11880,
	"./media/empty.png": 71782,
	"./media/gemiclogo.png": 64961,
	"./media/gemiclogo_white 2.png": 99542,
	"./media/gemiclogo_white.png": 53631,
	"./media/gradient.mp4": 26689,
	"./media/gradient02.mp4": 84429,
	"./media/help.svg": 2324,
	"./media/info.png": 32341,
	"./media/info_white.png": 58521,
	"./media/intro/bang.png": 18103,
	"./media/intro/cursor.png": 71287,
	"./media/intro/image01.png": 49853,
	"./media/intro/image02.png": 45019,
	"./media/intro/image04.gif": 3882,
	"./media/intro/image2.png": 96822,
	"./media/intro/koreaFlag.png": 59530,
	"./media/intro/landscapeMode.png": 23149,
	"./media/intro/laptop.png": 77186,
	"./media/intro/neonHeart.png": 41347,
	"./media/intro/neonHeart.svg": 59369,
	"./media/intro/neonHeart02.png": 25597,
	"./media/intro/neonMic.png": 19999,
	"./media/intro/neonMic.svg": 13720,
	"./media/intro/neonMic02.png": 82538,
	"./media/intro/slide01_gif01.gif": 15431,
	"./media/intro/slide01_gif02.gif": 43263,
	"./media/intro/slide01_gif03.gif": 33178,
	"./media/intro/slide02_01.png": 13694,
	"./media/intro/slide02_02.png": 89447,
	"./media/intro/slide02_03.png": 55987,
	"./media/intro/slide02_04a.png": 98993,
	"./media/intro/slide02_04b.gif": 8278,
	"./media/intro/slide02_04b.png": 98003,
	"./media/intro/slide02_05.png": 76899,
	"./media/intro/slide03_gif.gif": 65005,
	"./media/intro/slide04_01.png": 55522,
	"./media/intro/slide04_gifLeft.gif": 87840,
	"./media/intro/slide04_gifRight.gif": 39010,
	"./media/intro/slide05_01.png": 59088,
	"./media/intro/slide06_01.png": 99436,
	"./media/intro/slide06_02.png": 80991,
	"./media/intro/slide06_03.png": 11500,
	"./media/intro/slide06_04.png": 1378,
	"./media/intro/slide06_05.png": 55171,
	"./media/intro/slide06_06.png": 27088,
	"./media/intro/slide06_07.png": 45917,
	"./media/intro/slide06_iPhone.png": 61533,
	"./media/intro/slide06_shift01.png": 87027,
	"./media/intro/slide06_shift02.png": 89354,
	"./media/intro/slide06_shift03.png": 60382,
	"./media/intro/slide06_shift04.png": 62475,
	"./media/intro/slide06_shift05.png": 57656,
	"./media/intro/slide06_shift06.png": 20524,
	"./media/intro/slide06_shift07.png": 94564,
	"./media/intro/slide06_shift08.png": 34997,
	"./media/intro/slide07_01.png": 4682,
	"./media/intro/slide07_02.png": 93017,
	"./media/intro/slide07_03.png": 82573,
	"./media/intro/slide07_04.png": 18383,
	"./media/intro/slide08_01.png": 21342,
	"./media/intro/slide08_02.png": 64624,
	"./media/intro/slide08_03.png": 92485,
	"./media/intro/slide08_04.png": 25482,
	"./media/intro/slide08_05.png": 37346,
	"./media/intro/slide08_06.png": 81702,
	"./media/intro/slide08_07.png": 25442,
	"./media/intro/slide08_08.png": 80822,
	"./media/intro/slide08_exploring.png": 46323,
	"./media/intro/slide08_happy.png": 52311,
	"./media/intro/slideshow_bg1.jpg": 415,
	"./media/intro/slideshow_bg2.jpg": 62348,
	"./media/intro/slideshow_bg3.jpg": 48514,
	"./media/intro/slideshow_video01.mp4": 1677,
	"./media/intro/slideshow_video02.mp4": 50823,
	"./media/intro/slideshow_video03.mp4": 43338,
	"./media/intro/yy.png": 10448,
	"./media/intro/zz.png": 96737,
	"./media/introBG.png": 48314,
	"./media/introLayer0.png": 90025,
	"./media/introLayer1.png": 14694,
	"./media/introLight.png": 33132,
	"./media/introLighthouse.png": 38836,
	"./media/kimchi.png": 90534,
	"./media/left.png": 36631,
	"./media/loading.svg": 84943,
	"./media/logout.png": 13266,
	"./media/logout02.png": 83884,
	"./media/logout_white.png": 8119,
	"./media/magnifier.svg": 96740,
	"./media/market/00.png": 27536,
	"./media/market/01.png": 2079,
	"./media/maximize.svg": 99680,
	"./media/maximizeInactive.svg": 97474,
	"./media/minimize.svg": 14796,
	"./media/popupDriver.svg": 63353,
	"./media/popupNeed.svg": 2544,
	"./media/popupOpp.svg": 72282,
	"./media/popupSignal.svg": 58655,
	"./media/reels_Love.png": 37228,
	"./media/reels_Stick.png": 24479,
	"./media/rice.png": 49124,
	"./media/right.png": 6177,
	"./media/sand.jpg": 37434,
	"./media/sandClock.gif": 88251,
	"./media/smallNode.png": 30290,
	"./media/soju.png": 57741,
	"./media/spotify.png": 21360,
	"./media/spotify.svg": 64367,
	"./notionMedia/market/coverImage/Everyday intimany.png": 8774,
	"./notionMedia/market/coverImage/Glocalization.png": 26647,
	"./notionMedia/market/coverImage/Goal-oriented communities.png": 81907,
	"./notionMedia/market/coverImage/Hallyu Lifestyle.png": 58448,
	"./notionMedia/market/coverImage/Next-Gen Live Events.png": 81208,
	"./notionMedia/market/coverImage/Professional Fan.png": 14121,
	"./notionMedia/market/photoVideo/Brazilian fanchant.mp4": 71730,
	"./notionMedia/market/photoVideo/Brazilian hallyu.mp4": 1640,
	"./notionMedia/market/photoVideo/Brazilian random Kpop play dance.mp4": 42071,
	"./notionMedia/market/photoVideo/Brazilian20travel20to20Korea.jpg": 64573,
	"./notionMedia/market/photoVideo/Erica 1, soap operas.mp4": 67631,
	"./notionMedia/market/photoVideo/Erica 2, soft power Hallyu.mp4": 28240,
	"./notionMedia/market/photoVideo/Erica 3, distant fans on internet.mp4": 61934,
	"./notionMedia/market/photoVideo/Erica 4, fans and politics voting.mp4": 73908,
	"./notionMedia/market/photoVideo/Erica 5, live events.mp4": 4979,
	"./notionMedia/market/photoVideo/Erica 6, BTS fan hate.mp4": 30961,
	"./notionMedia/market/photoVideo/Hallyu20countries.jpg": 63868,
	"./notionMedia/market/photoVideo/Is Kpop against Islam.mp4": 91490,
	"./notionMedia/market/photoVideo/Kpop2520costumes.jpg": 43846,
	"./notionMedia/market/photoVideo/Tiffani merch unboxing.mp4": 63686,
	"./notionMedia/market/photoVideo/Tiffani20Afifa.jpg": 41037,
	"./notionMedia/market/photoVideo/Yuswan 1, intimacy and merch.mp4": 36970,
	"./notionMedia/market/photoVideo/Yuswan 2, merch scams.mp4": 74645,
	"./notionMedia/market/photoVideo/Yuswan 3, Coppamagz news.mp4": 42064,
	"./notionMedia/market/photoVideo/Yuswan 4, cendol cendol.mp4": 62470,
	"./notionMedia/market/photoVideo/Yuswan 5, go to Korea.mp4": 9910,
	"./notionMedia/market/photoVideo/Yuswan 6, toxic fans.mp4": 54758,
	"./notionMedia/market/photoVideo/Yuswan 7, global fandom.mp4": 42653,
	"./notionMedia/market/photoVideo/brazil-2.png": 87160,
	"./notionMedia/market/photoVideo/image6-2.jpg": 52382,
	"./notionMedia/market/photoVideo/indonesia-2.png": 97187,
	"./notionMedia/market/photoVideo/indonesian20merch.jpg": 99280,
	"./notionMedia/market/photoVideo/kpop2520collage.jpg": 41749,
	"./notionMedia/market/photoVideo/vaccination.mp4": 14271,
	"./notionMedia/opps/photoVideo/Accessing idol commodities.png": 44780,
	"./notionMedia/opps/photoVideo/Accessing idol commodities_2.png": 45482,
	"./notionMedia/opps/photoVideo/Aespa MV.mp4": 19893,
	"./notionMedia/opps/photoVideo/BTS Bollywood compressed cut.mp4": 88171,
	"./notionMedia/opps/photoVideo/BTS In the seom-min.png": 24412,
	"./notionMedia/opps/photoVideo/BTSDynamiteMilestones.jpg": 87461,
	"./notionMedia/opps/photoVideo/Collaborative spaces.png": 23343,
	"./notionMedia/opps/photoVideo/Collate artist media.png": 33972,
	"./notionMedia/opps/photoVideo/Connecting related content.png": 92332,
	"./notionMedia/opps/photoVideo/Contribution signifiers.png": 60654,
	"./notionMedia/opps/photoVideo/Contributor rewards_1.png": 81879,
	"./notionMedia/opps/photoVideo/Contributor rewards_2.png": 22989,
	"./notionMedia/opps/photoVideo/Digital _music memories__1.png": 17144,
	"./notionMedia/opps/photoVideo/Digital _music memories__2.png": 36306,
	"./notionMedia/opps/photoVideo/Enable service searches.png": 15894,
	"./notionMedia/opps/photoVideo/Fandance.MOV": 92039,
	"./notionMedia/opps/photoVideo/Finding communities_1.png": 25820,
	"./notionMedia/opps/photoVideo/Finding communities_3.png": 86539,
	"./notionMedia/opps/photoVideo/FindingCommunities-min.png": 37234,
	"./notionMedia/opps/photoVideo/HallyuMerch.jpeg": 88832,
	"./notionMedia/opps/photoVideo/Incentivize financial investment.png": 42964,
	"./notionMedia/opps/photoVideo/Instant engagement.png": 11676,
	"./notionMedia/opps/photoVideo/K-pop & Web3.png": 51209,
	"./notionMedia/opps/photoVideo/KCON LA compressed.mp4": 82635,
	"./notionMedia/opps/photoVideo/KProfilesForum.jpeg": 70278,
	"./notionMedia/opps/photoVideo/KisweVenewLive-min.png": 46581,
	"./notionMedia/opps/photoVideo/Learning through lyrics.png": 18760,
	"./notionMedia/opps/photoVideo/Music as connector_1.png": 94608,
	"./notionMedia/opps/photoVideo/NewJeans app.mp4": 21723,
	"./notionMedia/opps/photoVideo/OpenSeaNFTs-min.png": 8641,
	"./notionMedia/opps/photoVideo/Promoting Hallyu merch.png": 77534,
	"./notionMedia/opps/photoVideo/Real-time communication_1.png": 84185,
	"./notionMedia/opps/photoVideo/Real-time communication_2.png": 61550,
	"./notionMedia/opps/photoVideo/Reddit Kfashion.png": 94942,
	"./notionMedia/opps/photoVideo/Showcase fan services.png": 75411,
	"./notionMedia/opps/photoVideo/Showcasing fanart.png": 98115,
	"./notionMedia/opps/photoVideo/Showcasing local remixes.png": 24152,
	"./notionMedia/opps/photoVideo/Showcasing loyalty.png": 42895,
	"./notionMedia/opps/photoVideo/Signaling artist presence.png": 59808,
	"./notionMedia/opps/photoVideo/Story world libraries.png": 38203,
	"./notionMedia/opps/photoVideo/Story-driven gamification_2.png": 79918,
	"./notionMedia/opps/photoVideo/Streamline moderation.png": 12850,
	"./notionMedia/opps/photoVideo/Supporting influencers.png": 83186,
	"./notionMedia/opps/photoVideo/TWICE VIP package.jpg": 71846,
	"./notionMedia/opps/photoVideo/Targeting local fans.png": 10295,
	"./notionMedia/opps/photoVideo/Tracking engagement.png": 14091,
	"./notionMedia/opps/photoVideo/Translations and filters.png": 51729,
	"./notionMedia/opps/photoVideo/UI mode toggles_1.png": 53987,
	"./notionMedia/opps/photoVideo/Visible metrics_1.png": 83573,
	"./notionMedia/opps/photoVideo/Visible metrics_2.png": 28764,
	"./notionMedia/opps/photoVideo/Webtoonplaylist-min.png": 81634,
	"./notionMedia/opps/photoVideo/WeverseMEDIATAB_compressed.mp4": 51394,
	"./notionMedia/opps/photoVideo/WeverseMediatab.png": 8299,
	"./notionMedia/opps/photoVideo/Wyth.png": 92436,
	"./notionMedia/opps/photoVideo/Zepeto2.mp4": 62847,
	"./notionMedia/opps/photoVideo/atatglance.jpg": 68972,
	"./notionMedia/opps/photoVideo/blackpinkhouse.jpg": 32809,
	"./notionMedia/opps/photoVideo/bts photocards.jpg": 15567,
	"./notionMedia/opps/photoVideo/bts-jimin-fortnite-dance.mp4": 47677,
	"./notionMedia/opps/photoVideo/bts-universe-story-screens.jpeg": 21899,
	"./notionMedia/opps/photoVideo/btsconnect-min.png": 71401,
	"./notionMedia/opps/photoVideo/etiquette-min.png": 83754,
	"./notionMedia/opps/photoVideo/fortnitebts-min.png": 97749,
	"./notionMedia/opps/photoVideo/idoltaxonomies-min.png": 57021,
	"./notionMedia/opps/photoVideo/kingdomConcept.jpeg": 54312,
	"./notionMedia/opps/photoVideo/kopophotocardsisgi-min.png": 26926,
	"./notionMedia/opps/photoVideo/kpop dances.jpeg": 24035,
	"./notionMedia/opps/photoVideo/kpopbytweets-min.png": 33967,
	"./notionMedia/opps/photoVideo/merchwweverse.jpeg": 97348,
	"./notionMedia/opps/photoVideo/metaverse world.jpg": 86073,
	"./notionMedia/opps/photoVideo/musicow.jpeg": 17367,
	"./notionMedia/opps/photoVideo/phoningnewjeans-min.png": 48224,
	"./notionMedia/opps/photoVideo/retrometrics.jpeg": 47291,
	"./notionMedia/opps/photoVideo/spotify discovery.jpg": 80025,
	"./notionMedia/opps/photoVideo/storyline-min.png": 83637,
	"./notionMedia/shifts/photoVideo/Hallyu.jpeg": 89167,
	"./notionMedia/shifts/photoVideo/Screenshot202022-09-1420at2011.34.08.jpg": 67838,
	"./notionMedia/shifts/photoVideo/WJSN-CHOCOME-Hmph-Music-Video-Fashion-Review-Ashtalkskpop-43-2.jpeg": 4428,
	"./notionMedia/shifts/photoVideo/c1_1928596_200603121036_700.jpeg": 55327,
	"./notionMedia/shifts/photoVideo/ezgif-3-1bde788793.gif": 6852,
	"./notionMedia/shifts/photoVideo/fullsizephoto223356.jpeg": 17516,
	"./notionMedia/shifts/photoVideo/maxresdefault.jpeg": 90699,
	"./notionMedia/shifts/photoVideo/unnamed.jpeg": 43772,
	"./notionMedia/signals/photoVideo/0107dc_96beb3661afd4d839eb149d369f7b02b_mv2-2.jpeg": 4732,
	"./notionMedia/signals/photoVideo/10-most-influential-contemporary-kpop-choreography.jpeg": 24709,
	"./notionMedia/signals/photoVideo/12-2.jpeg": 58977,
	"./notionMedia/signals/photoVideo/1298592-2.jpeg": 12390,
	"./notionMedia/signals/photoVideo/7 Fates webtoon compressed.mp4": 42386,
	"./notionMedia/signals/photoVideo/Animating fantasies.jpg": 39013,
	"./notionMedia/signals/photoVideo/BTS Bollywood compressed.mp4": 49417,
	"./notionMedia/signals/photoVideo/BTS Island Cut.mp4": 74203,
	"./notionMedia/signals/photoVideo/BTS Universe story cut.mp4": 40863,
	"./notionMedia/signals/photoVideo/Banking on prosumers.png": 63830,
	"./notionMedia/signals/photoVideo/Blackpink How you like that compressed.mp4": 58650,
	"./notionMedia/signals/photoVideo/Boosting feminist ideals.jpg": 50178,
	"./notionMedia/signals/photoVideo/Brand collaborations.jpg": 89242,
	"./notionMedia/signals/photoVideo/Breaking language barriers.png": 87006,
	"./notionMedia/signals/photoVideo/Buying to bridge the gap.jpg": 6618,
	"./notionMedia/signals/photoVideo/Chat room hangouts.jpg": 64946,
	"./notionMedia/signals/photoVideo/Climbing the leaderboard.png": 5086,
	"./notionMedia/signals/photoVideo/Collectible glamor shots.png": 9865,
	"./notionMedia/signals/photoVideo/Connection through content.png": 32336,
	"./notionMedia/signals/photoVideo/Contributing while consuming.jpg": 75653,
	"./notionMedia/signals/photoVideo/Craving local love.jpg": 32865,
	"./notionMedia/signals/photoVideo/Creative20entrepreneurship-2.png": 61826,
	"./notionMedia/signals/photoVideo/Crowdfunding for participation.png": 68881,
	"./notionMedia/signals/photoVideo/Decentralized business communities.jpg": 50487,
	"./notionMedia/signals/photoVideo/E8FBn5QVkAIsg6x-2.jpeg": 2157,
	"./notionMedia/signals/photoVideo/EhxpAYzU8AErhZI.jpeg": 22650,
	"./notionMedia/signals/photoVideo/Fan work as livelihood.jpg": 56125,
	"./notionMedia/signals/photoVideo/FavorableHomelyHeron-mobile.mp4": 83772,
	"./notionMedia/signals/photoVideo/Follow, share, earn.png": 9659,
	"./notionMedia/signals/photoVideo/From idol to actor.jpg": 17436,
	"./notionMedia/signals/photoVideo/Gamified giving initiatives.jpg": 93955,
	"./notionMedia/signals/photoVideo/Global K-pop academies.jpg": 57540,
	"./notionMedia/signals/photoVideo/Global Korean words_2.png": 83181,
	"./notionMedia/signals/photoVideo/Global Korean words_3.png": 93969,
	"./notionMedia/signals/photoVideo/Global-first orientation.jpg": 63241,
	"./notionMedia/signals/photoVideo/Globalizing K-indie.jpg": 57415,
	"./notionMedia/signals/photoVideo/Immersive XR_AR events.png": 90242,
	"./notionMedia/signals/photoVideo/International artists in K-pop.jpg": 98487,
	"./notionMedia/signals/photoVideo/Internet watchdogs_1.png": 92769,
	"./notionMedia/signals/photoVideo/Internet watchdogs_2.png": 85037,
	"./notionMedia/signals/photoVideo/Interview9SubbedCompressed.mp4": 55208,
	"./notionMedia/signals/photoVideo/Investing for love_1.png": 86989,
	"./notionMedia/signals/photoVideo/Investing for love_2.png": 87920,
	"./notionMedia/signals/photoVideo/K-pop + food brands.jpg": 49954,
	"./notionMedia/signals/photoVideo/Kingdom MV compressed.mp4": 16327,
	"./notionMedia/signals/photoVideo/Kiswe Live.mp4": 23972,
	"./notionMedia/signals/photoVideo/Korea as lifestyle goal.jpg": 85529,
	"./notionMedia/signals/photoVideo/Korean language crazes.png": 16545,
	"./notionMedia/signals/photoVideo/Live voting events.jpg": 851,
	"./notionMedia/signals/photoVideo/Livestreams as state investments.png": 78444,
	"./notionMedia/signals/photoVideo/Making and selling fanart.jpg": 40758,
	"./notionMedia/signals/photoVideo/Merch = pleasure + status.jpg": 71241,
	"./notionMedia/signals/photoVideo/Merch = pleasure + status_2.jpg": 65437,
	"./notionMedia/signals/photoVideo/Multilingual K-pop dictionary.png": 59123,
	"./notionMedia/signals/photoVideo/Musicow.mp4": 52180,
	"./notionMedia/signals/photoVideo/NFTs for VIP access.jpg": 35083,
	"./notionMedia/signals/photoVideo/Nurturing local K-pop.jpg": 39065,
	"./notionMedia/signals/photoVideo/Nurturing pseudo-relationships_1.png": 91864,
	"./notionMedia/signals/photoVideo/Nurturing pseudo-relationships_2.png": 55889,
	"./notionMedia/signals/photoVideo/PUBG Blackpink cut.mp4": 36319,
	"./notionMedia/signals/photoVideo/Parasocial bonds.jpg": 89985,
	"./notionMedia/signals/photoVideo/Partnership opportunities.png": 71012,
	"./notionMedia/signals/photoVideo/Personalized interactions.jpg": 1289,
	"./notionMedia/signals/photoVideo/Promoting Korea's national brand.png": 29291,
	"./notionMedia/signals/photoVideo/Providing specialized translations.png": 44989,
	"./notionMedia/signals/photoVideo/Pursuing shared objectives_1.jpg": 68224,
	"./notionMedia/signals/photoVideo/Pursuing shared objectives_2.png": 98283,
	"./notionMedia/signals/photoVideo/Quantified milestones.png": 37356,
	"./notionMedia/signals/photoVideo/RM.jpeg": 70300,
	"./notionMedia/signals/photoVideo/Real-time updates.png": 36924,
	"./notionMedia/signals/photoVideo/Redefining masculinity.jpg": 86158,
	"./notionMedia/signals/photoVideo/Reselling collectible photocards.jpg": 48193,
	"./notionMedia/signals/photoVideo/Seeking cultural adaptations.jpg": 12611,
	"./notionMedia/signals/photoVideo/Socializing through goals.jpg": 4068,
	"./notionMedia/signals/photoVideo/Sparking cultural tensions.jpg": 30529,
	"./notionMedia/signals/photoVideo/SpotifyIsland.mp4": 95813,
	"./notionMedia/signals/photoVideo/Superkind Saejin.mp4": 43356,
	"./notionMedia/signals/photoVideo/Supplying idol outfits.jpg": 59347,
	"./notionMedia/signals/photoVideo/Syncing remote participation.png": 46003,
	"./notionMedia/signals/photoVideo/Themed eating experiences.jpg": 84640,
	"./notionMedia/signals/photoVideo/Token economies.jpg": 83439,
	"./notionMedia/signals/photoVideo/Tracking rites of passage.png": 73190,
	"./notionMedia/signals/photoVideo/Visual-music integration.jpg": 17588,
	"./notionMedia/signals/photoVideo/WYTH compressed.mp4": 1463,
	"./notionMedia/signals/photoVideo/Zepeto 2 promotion.mp4": 13914,
	"./notionMedia/signals/photoVideo/ZepetoBlackpink.mp4": 19494,
	"./notionMedia/signals/photoVideo/[TinyTAN l ANIMATION] - Magic Door.mp4": 61688,
	"./notionMedia/signals/photoVideo/blackpink-how-you-like-that.mp4": 19810,
	"./notionMedia/signals/photoVideo/bts-jimin-fortnite-dance.mp4": 50721,
	"./notionMedia/signals/photoVideo/dreamcatcher-FI-2048x1170-2.jpeg": 14710,
	"./notionMedia/signals/photoVideo/ezgif-4-1fae935dde.jpeg": 64782,
	"./notionMedia/signals/photoVideo/ezgif-4-e7864f14a3-2.jpeg": 20092,
	"./notionMedia/signals/photoVideo/how-lightsticks-became-a-must-have-item-for-k-pop-fans_dspy.2496-2.jpg": 71509,
	"./notionMedia/signals/photoVideo/indiaseoul-2.jpeg": 6000,
	"./notionMedia/signals/photoVideo/laugh-jisoo.mp4": 37759,
	"./notionMedia/signals/photoVideo/maxresdefault.jpeg": 95786,
	"./reportWebVitals": 54013,
	"./reportWebVitals.js": 54013,
	"./setupTests": 79511,
	"./setupTests.js": 79511,
	"./useFetch": 53582,
	"./useFetch.js": 53582,
	"./useFetchOld": 56949,
	"./useFetchOld.js": 56949,
	"./useFetchPost": 79715,
	"./useFetchPost.js": 79715,
	"./vis-network.min.css": 8595
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40407;